module.exports = __webpack_public_path__ + "static/media/object_treasure.3a76036b.png";